export const DEFAULT_INSTALLATION_MODE = 'integrated'

export const LandingType = {
  Unassigned: 'unassigned',
  Assigned: 'assigned',
  DigitalRetail: 'dr',
  OEM: 'oem'
}
